// Shared "unread" semantics for notifications.
//
// A notification's `seen` field is a single array shared by every recipient
// of that notification (role-based / every_one broadcasts all point at one
// document; notifications-service does `$addToSet: { seen: userId }` per
// recipient). So "unread" must be evaluated per-user — whether *this* user's
// id is absent from `seen` — never by checking whether the array is merely
// non-empty, which would treat one recipient's read as everyone's read.
export interface NotificationSeenInfo {
  seen?: readonly (string | null | undefined)[] | null;
}

export function getCurrentUserId(): string | null {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?._id ?? parsed?.id ?? parsed?.userId ?? null;
  } catch {
    return null;
  }
}

export function isNotificationUnreadForUser(
  notification: NotificationSeenInfo,
  userId: string | null,
): boolean {
  const seen = notification.seen;
  if (!seen || seen.length === 0) return true;
  if (!userId) return true;
  return !seen.includes(userId);
}

export function countUnreadNotifications(
  notifications: readonly NotificationSeenInfo[],
  userId: string | null,
): number {
  return notifications.filter((notification) =>
    isNotificationUnreadForUser(notification, userId),
  ).length;
}
